import React from 'react';
import { ContainerLayout, HeaderBar, ScrollableContainer } from 'components/index';
import { ProfileView } from 'components/ProfileView/ProfileView';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { useLoggedInUser, useUserInitials } from 'features/auth/hooks/useAuthData';
import { useCobrand } from 'features/cobrand/hooks/useCobrandUtils';
import { getMembershipDayNumber } from 'utils';

export const Profile = () => {
  const { translation } = useTranslationContext();
  const { cobrand } = useCobrand();
  const user = useLoggedInUser();
  const initials = useUserInitials();

  const fullName = `${user?.first_name ?? ''} ${user?.last_name ?? ''}`.trim();
  const dayNumber = user?.enrollment_date ? getMembershipDayNumber(user.enrollment_date) : 1;
  const healthGoal = user?.member_health_goal;

  return (
    <ContainerLayout>
      <HeaderBar titleId="profile_tab_text" heading={translation('profile_tab_text')} />
      <ScrollableContainer role="main" aria-labelledby="profile_tab_text">
        <ProfileView
          header={{
            initials,
            name: fullName,
            subtitle: translation('member_days_on_app', {
              arg1: dayNumber,
              arg2: cobrand.displayName,
            }),
          }}
          // TODO: Map the goal to its translated title + illustration; wire onEdit once editing exists.
          healthGoal={healthGoal ? { title: healthGoal, icon: null } : undefined}
          // TODO: Populate from the member's medications and reminders once their API is integrated.
          medications={[]}
          healthReminders={[]}
        />
      </ScrollableContainer>
    </ContainerLayout>
  );
};
